import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../colorVars';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../utils/math/ApplyRounding';
import { TopRowBox } from '../topRows/topRowBox/TopRowBox';
import { buildMarketDataKeys } from '../../../../../../stores/websocketStore/utils/marketDataRouting';
import { liveQuoteUnrealizedPnl } from './liveQuoteUnrealizedPnl';

const PnLDisplay = observer(({ tradePlanId, symbol, dataSource, brokerage }) => {
  const { tradePlanStore, priceDataStore  } = useWebsocketStore();
  const metrics = tradePlanStore.getTradePlanPositionMetrics(tradePlanId);
  const hash = symbol
    ? buildMarketDataKeys({ symbol, dataSource, brokerage }).find(
        (key) => priceDataStore.lastQuote[key]
      )
    : null;
  const quote = hash ? priceDataStore.lastQuote[hash] : null;
  const quotePnl = liveQuoteUnrealizedPnl({ metrics, quote });
  const unrealizedPnl = quotePnl ?? metrics?.unrealizedPnl ?? null;
  const realizedPnl = metrics?.realizedPnl ?? null;

  // let uPnlClassname;
  // let rPnlClassname;

  // if (unrealizedPnl < 0) uPnlClassname = style.loss;
  // else if (unrealizedPnl === 0) uPnlClassname = style.breakEven;
  // else uPnlClassname = style.profit;

  // if (realizedPnl < 0) rPnlClassname = style.loss;
  // else if (realizedPnl === 0) rPnlClassname = style.breakEven;
  // else rPnlClassname = style.profit;

  return (
    // <div className={style.container} style={{ backgroundColor: colors.grey }}>
    //   <span className={uPnlClassname}>uPnL: {ApplyRounding(unrealizedPnl, 2)}</span>
    //   <span className={rPnlClassname}>rPnL: {ApplyRounding(realizedPnl, 2)}</span>
    // </div>
    <>
      <TopRowBox width="100px" backgroundColor={colors.grey} color={unrealizedPnl == null ? colors.lightGrey : unrealizedPnl < 0 ? colors.red : unrealizedPnl > 0 ? colors.green : colors.lightGrey}>{`uPnL: ${unrealizedPnl == null ? '--' : ApplyRounding(unrealizedPnl, 2)}`}</TopRowBox>
      <TopRowBox width="100px" backgroundColor={colors.grey} color={realizedPnl == null ? colors.lightGrey : realizedPnl < 0 ? colors.red : realizedPnl > 0 ? colors.green : colors.lightGrey}>{`rPnL: ${realizedPnl == null ? '--' : ApplyRounding(realizedPnl, 2)}`}</TopRowBox>
    </>
  );
});

PnLDisplay.propTypes = {
  tradePlanId: PropTypes.string,
  symbol: PropTypes.string,
  dataSource: PropTypes.string,
  brokerage: PropTypes.string,
};

export default PnLDisplay;
